// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"73f26697","488":"0a12ffde","528":"f944fc15","529":"36417f67","960":"f944fc15"}[chunkId] + ".chunk.css";
};